import { tv, type VariantProps } from 'tailwind-variants';
export type AtClickableVariants = VariantProps<typeof atClickable>;

const atClickable = tv({
  base: 'group',
  slots: {
    iconWrapper: '',
    iconColor: '',
  },
  variants: {
    outline: {
      true: '',
      false: '',
    },
    iconPosition: {
      left: {
        iconWrapper: 'flex-row-reverse gap-2 justify-center',
      },
      right: {
        iconWrapper: 'flex-row gap-2 justify-center',
      },
      none: '',
    },
    intent: {
      primary: {
        base: '',
        iconColor: '',
      },
      secondary: {
        base: '',
        iconColor: '',
      },
      tertiary: {
        base: '',
        iconColor: '',
      },
      diminutive: {
        base: 'cta-diminutive',
        iconColor: '',
      },
    },
    size: {
      sm: '',
      lg: '',
    },
    type: {
      cta: 'cta-base',
      isolatedLink: 'isolated-link-base',
      isolatedIcon: 'isolated-icon-base',
      logo: 'logo',
    },
  },
  compoundVariants: [
    // CTA
    // BASE STYLES
    {
      type: 'cta',
      outline: true,
      className: {
        base: 'cta-base-outline',
      },
    },
    {
      type: 'cta',
      outline: false,
      className: {
        base: 'cta-base-filled',
      },
    },
    {
      type: 'cta',
      size: 'sm',
      className: 'cta-text-sm',
    },
    {
      type: 'cta',
      size: 'lg',
      className: 'cta-text-lg',
    },

    // CTA PRIMARY
    {
      type: 'cta',
      intent: 'primary',
      outline: false,
      className: {
        base: 'bg-cta-primary focus:ring-offset-cta-fill-primary focus:ring-cta-fill-primary text-cta-fill-primary focus:bg-ctaHover-primary hover:bg-ctaHover-primary',
        iconColor: 'var(--color-button-text-primary)',
      },
    },
    {
      type: 'cta',
      intent: 'primary',
      outline: true,
      className: {
        base: '!outline-cta-primary text-cta-outline-primary focus:ring-offset-cta-outline focus:ring-cta-outline-primary focus:ring-2',
        iconColor: 'var(--color-button-outline-text-primary)',
      },
    },

    // SECONDARY
    {
      type: 'cta',
      intent: 'secondary',
      outline: false,
      className: {
        base: 'bg-cta-secondary focus:ring-offset-cta-fill-secondary focus:ring-cta-fill-secondary text-cta-fill-secondary focus:bg-ctaHover-secondary hover:bg-ctaHover-secondary',
        iconColor: 'var(--color-button-text-secondary)',
      },
    },
    {
      type: 'cta',
      intent: 'secondary',
      outline: true,
      className: {
        base: '!outline-cta-secondary text-cta-outline-secondary focus:ring-offset-cta-outline focus:ring-cta-outline-secondary focus:ring-2',
        iconColor: 'var(--color-button-outline-text-secondary)',
      },
    },

    // TERTIARY
    {
      type: 'cta',
      intent: 'tertiary',
      outline: false,
      className: {
        base: 'bg-cta-tertiary focus:ring-offset-cta-fill-tertiary focus:ring-cta-fill-tertiary text-cta-fill-tertiary focus:bg-ctaHover-tertiary hover:bg-ctaHover-tertiary',
        iconColor: 'var(--color-button-text-tertiary)',
      },
    },
    {
      type: 'cta',
      intent: 'tertiary',
      outline: true,
      className: {
        base: '!outline-cta-tertiary text-cta-outline-tertiary focus:ring-offset-cta-outline focus:ring-cta-outline-tertiary focus:ring-2',
        iconColor: 'var(--color-button-outline-text-tertiary)',
      },
    },
    {
      type: 'cta',
      intent: 'diminutive',
      className: {
        iconColor: 'var(--color-button-text-diminutive)',
      },
    },

    // ISOLATED LINKS
    // PRIMARY
    {
      type: 'isolatedLink',
      intent: 'primary',
      size: 'sm',
      className: 'link-text-sm',
    },
    {
      type: 'isolatedLink',
      className: {
        iconColor: 'var(--color-page-link-text)',
      },
    },
    {
      type: 'isolatedLink',
      intent: 'primary',
      size: 'lg',
      className: 'link-text-lg',
    },

    // SECONDARY
    {
      type: 'isolatedLink',
      intent: 'secondary',
      size: 'sm',
      className: 'link-text-secondary-sm',
    },
    {
      type: 'isolatedLink',
      intent: 'secondary',
      size: 'lg',
      className: 'link-text-secondary-lg',
    },
    // TERTIARY
    // No teriary isolated link
    {
      type: 'isolatedLink',
      intent: 'secondary',
      size: 'sm',
      className: 'link-text-secondary-sm',
    },
    {
      type: 'isolatedLink',
      intent: 'secondary',
      size: 'lg',
      className: 'link-text-secondary-lg',
    },
    {
      type: 'logo',
      className: {
        base: 'cta-base logo-focus-override',
      },
    },
  ],
});

export default atClickable;
